import { Injectable } from '@angular/core';
import { BackendStore } from './backend.store';
import { BackendQuery } from './backend.query';
import { ApiStatusService } from '../../services/api-status.service';
import { withLatestFrom } from 'rxjs/operators';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  constructor(
    private backendStore: BackendStore,
    private backendQuery: BackendQuery,
    private status: ApiStatusService,
    private sessionService: SessionService
  ) {}

  /**
   * Define State of backend.
   */
  checkBackendStatus(): void {
    this.status
      .getApiStatus()
      .pipe(withLatestFrom(this.backendQuery.select()))
      .subscribe({
        next: ([api, state]) => {
          if (state.online && state.servicePause && !api.servicePause) {
            this.servicePauseOver();
          } else if (
            !state.online &&
            !state.servicePause &&
            !api.servicePause
          ) {
            this.backendOnline();
          } else if (!state.online && state.servicePause && !api.servicePause) {
            this.backendOnline();
            this.servicePauseOver();
          } else if (api.servicePause) {
            this.servicePauseActive();
            this.sessionService.setChronoVersion(api.chronoVersion);
          } else {
            this.backendOnline();
            this.servicePauseOver();
            this.sessionService.setChronoVersion(api.chronoVersion);
          }
        },
        error: () => this.backendOffline(),
      });
  }

  backendOffline() {
    this.backendStore.update((state) => ({
      ...state,
      online: false,
    }));
  }

  servicePauseActive() {
    this.backendStore.update((state) => ({
      ...state,
      servicePause: true,
    }));
  }

  servicePauseOver() {
    this.backendStore.update((state) => ({
      ...state,
      servicePause: false,
    }));
  }

  backendOnline() {
    this.backendStore.update((state) => ({
      ...state,
      online: true,
    }));
  }
}
